import { stringify } from "query-string";
import {
  GET_LIST,
  GET_ONE,
  GET_MANY,
  CREATE,
  UPDATE,
  DELETE
} from "react-admin";
import { auth } from "../../firebase";
import { QA_API_ERROR } from "../../util";

const convertContentToString = setting => {
  const clone = Object.assign({}, setting);
  clone.content = JSON.stringify(setting.content);
  return clone;
};

const processSetting = setting => {
  return convertContentToString(setting);
};

const processSettings = settings => {
  return settings.map(s => processSetting(s));
};

const SettingProvider = opt => {
  const { config, httpClient } = opt;
  if (!config) {
    throw new Error("Missing config");
  }
  if (!httpClient) {
    throw new Error("Missing httpClient");
  }
  const provider = {
    handle(type, params) {
      switch (type) {
        case GET_LIST:
          return provider.list(params);
        case GET_ONE:
          return provider.get(params);
        case GET_MANY:
          return provider.getMany(params);
        case CREATE:
          return provider.create(params);
        case UPDATE:
          return provider.update(params);
        case DELETE:
          return provider.delete(params);
        default:
          throw new Error(`Unsupported action type: ${type}`);
      }
    },
    get(params) {
      return httpClient
        .get(`/api/settings/${params.id}`)
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("SettingProvider.get Error", result, params);
          }
          let response = {
            data: processSetting(result.setting)
          };
          return response;
        });
    },
    getMany(params) {
      const query = {
        ids: params.ids
      };
      return httpClient
        .get(`/api/settings?${stringify(query)}`)
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("SettingProvider.getMany Error", result, params);
          }
          const response = {
            data: processSettings(result.settings || [])
          };
          return response;
        });
    },
    list(params) {
      const query = {
        order: params.sort.field,
        sort: params.sort.order.toLowerCase(),
        limit: params.pagination.perPage
      };
      if (typeof params.pagination.page === "string") {
        const [pageNumber, afterOrBefore, id] = params.pagination.page.split(
          "_"
        );
        if (afterOrBefore === "after") {
          query.after = id;
        } else if (afterOrBefore === "before") {
          query.before = id;
        }
        console.log("pageNumber: ", pageNumber);
      }
      return httpClient
        .get(`/api/settings?${stringify(query)}`)
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("SettingProvider.list Error", result, params);
          }
          let response = {
            data: processSettings(result.settings || []),
            total: 1000
          };
          return response;
        });
    },
    create(params) {
      return auth.currentUser
        .getIdToken(false)
        .then(token => {
          const payload = {
            token,
            id: params.data.id,
            name: params.data.name,
            content: JSON.parse(params.data.content)
          };
          return httpClient.post(`/api/settings`, payload);
        })
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("SettingProvider.create Error", result, params);
          }
          const response = {
            data: processSetting(result.setting)
          };
          return response;
        });
    },
    update(params) {
      return auth.currentUser
        .getIdToken(false)
        .then(token => {
          const payload = {
            token,
            name: params.data.name,
            content: JSON.parse(params.data.content)
          };
          return httpClient.put(`/api/settings/${params.id}`, payload);
        })
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("SettingProvider.update Error", result, params);
          }
          const response = {
            data: processSetting(result.setting)
          };
          return response;
        });
    },
    delete(params) {
      return auth.currentUser
        .getIdToken(false)
        .then(token => {
          const payload = {
            token
          };
          return httpClient.delete(`/api/settings/${params.id}`, {
            data: payload
          });
        })
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("SettingProvider.delete Error", result, params);
          }
          const response = {
            data: processSetting(result.deleted)
          };
          return response;
        });
    }
  };
  return provider;
};

export default SettingProvider;
